import moment from 'moment'
import { IFilter } from '../store/ducks/report/types'
import { IAxiosResponse } from '../store/ducks/root.types'
import axiosInstance from './axios'


class ReportService {

  constructor(private apiVersion: string = 'v1') { }
  /**
   * Returns all registered reports
   * @param {IFilter?} filter 
   * @returns {any[]} data
   * @returns {any} headers
   */
  public async getAll(filter?: IFilter): Promise<IAxiosResponse<any>> {
    const params: URLSearchParams = this.buildParams(filter)
    return axiosInstance

      .get(`${this.apiVersion}/reports`, { params })
      .then((response) => {
        return {
          data: response.data,
          headers: response.headers
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar dados:", error)
        throw error
      })
  }
  /**
   * Returns general data from all completed questionnaires in the active search.
   * @param {IFilter?} filter 
   * @returns {any[]} data
   * @returns {any} headers
   */
  public async getActiveSearchSummary(filter?: IFilter) {
    const params: URLSearchParams = this.buildParams(filter)
    return axiosInstance
      .get(`${this.apiVersion}/forms-report`, {
        params,
        headers: {
          'api-key': `${process.env.REACT_APP_API_KEY}`
        }
      })
      .then((response) => {
        return {
          data: response.data,
          headers: response.headers
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar dados:", error)
        throw error
      })
  }
  /**
   * Returns a summary of the response rate according to the question types in the active search.
   * @param {IFilter?} filter 
   * @returns {any[]} data
   * @returns {any} headers
   */
  public async getActiveSearchResponse(filter?: IFilter) {
    const params: URLSearchParams = this.buildParams(filter)
    return axiosInstance
      .get(`${this.apiVersion}/form/questionnaire-report`, {
        params,
        headers: {
          'api-key': `${process.env.REACT_APP_API_KEY}`
        }
      })
      .then((response) => {
        return {
          data: response.data,
          headers: response.headers
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar dados:", error)
        throw error
      })
  }

  /**
   * Build Params
   * @param {IFilter?} filter 
   * @returns {URLSearchParams} params 
   */
  public buildParams(filter?: IFilter): URLSearchParams {
    const params = new URLSearchParams()
    if (filter) {

      if (filter.primaryDate && filter.secondaryDate) {
        if (moment(filter.primaryDate).isAfter(filter.secondaryDate)) {
          params.append(`created_at`, `gte:${filter.secondaryDate}`)
          params.append(`created_at`, `lte:${filter.primaryDate}T23:59:59z`)
        }
        else {
          params.append(`created_at`, `gte:${filter.primaryDate}`)
          params.append(`created_at`, `lte:${filter.secondaryDate}T23:59:59z`)
        }
      }
      if (filter.state) {
        params.append(`address.state`, `${filter.state}`)
      }
      if (filter.addressCity) {
        params.append(`address.city`, `${filter.addressCity}`)
      }
      
      if (filter?.month) {
        params.append(`updated_at`, `gte:${filter.month.startDate}`)
        params.append(`updated_at`, `lte:${filter.month.endDate}T23:59:59z`)
      }

    }
    return params
  }
}
const reportService = new ReportService()

export default reportService